const API_URL = process.env.REACT_APP_API_URL || '/api'
const STILL_ALIVE_MODAL_DIFF_TIME = 180000
const LOGOUT_DIFF_TIME = 30000

export { API_URL, STILL_ALIVE_MODAL_DIFF_TIME, LOGOUT_DIFF_TIME }
